import Vue from 'vue'
import Vuex from 'vuex'

import Auth, { State as AuthState } from './modules/auth'
import Home, { State as HomeState } from './modules/home'
import User, { State as UsersState } from './modules/users'
import Flash, { State as FlashState } from './modules/flash'
import Notices, { State as NoticesState } from './modules/notices'
import Benefits, { State as BenefitsState } from './modules/benefits'
import Tickets, { State as TicketsState } from './modules/tickets'
import Registration, { State as RegistrationState } from './modules/registration'
import Transactions, { State as TransactionsState } from './modules/transactions'
import Twitter, { State as TwitterState } from './modules/twitter'
import Stamps, { State as StampsState } from './modules/stamps'
import FAQ, { State as FAQState } from './modules/faq'

Vue.use(Vuex)

export interface State {
  auth: AuthState
  home: HomeState
  users: UsersState
  flash: FlashState
  notices: NoticesState
  benefits: BenefitsState
  tickets: TicketsState
  registration: RegistrationState
  transactions: TransactionsState
  twitter: TwitterState
  stamps: StampsState
  faq: FAQState
}

export default new Vuex.Store({
  modules: {
    auth: Auth,
    home: Home,
    users: User,
    flash: Flash,
    notices: Notices,
    benefits: Benefits,
    tickets: Tickets,
    registration: Registration,
    transactions: Transactions,
    twitter: Twitter,
    stamps: Stamps,
    faq: FAQ
  }
})
